import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client/react';

import { useApolloError } from 'common/hooks/useApolloError';
import {
    CourseManagerTokenDocument,
    CourseStudentTokenDocument,
} from 'graphql/types';

/**
 * Hook to open a course in edit or view mode
 */
export const useOpenCourse = () => {
    const { showApolloError } = useApolloError();

    const [getCourseManagerToken, { loading: loadingManagerToken }] =
        useLazyQuery(CourseManagerTokenDocument);

    const [getCourseStudentToken, { loading: loadingStudentToken }] =
        useLazyQuery(CourseStudentTokenDocument);

    const openCourseEdit = useCallback(
        async (id: string) => {
            const returnUrl = `${window.location.href}?course=${id}`;
            let url: string | undefined;

            try {
                const response = await getCourseManagerToken({
                    variables: { id, returnUrl },
                });

                url = response.data?.courseManagerToken?.url;
            } catch (error) {
                showApolloError(error);

                return;
            }

            if (!url) return;

            window.location.href = url;
        },
        [getCourseManagerToken]
    );

    const openCourseView = useCallback(
        async (id: string) => {
            const returnUrl = `${window.location.href}?course=${id}`;
            let url: string | undefined;

            try {
                const response = await getCourseStudentToken({
                    variables: { id, returnUrl },
                });

                url = response.data?.courseStudentToken?.url;
            } catch (error) {
                showApolloError(error);

                return;
            }

            if (!url) return;

            window.location.href = url;
        },
        [getCourseStudentToken]
    );

    return {
        openCourseView,
        openCourseEdit,
        loadingCourseView: loadingStudentToken,
        loadingCourseEdit: loadingManagerToken,
        loading: loadingManagerToken || loadingStudentToken,
    };
};
